// AdminRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute .jsx";
import AdminPanelLayout from "../AdminPanel/AdminPanelLayout.jsx";
import AdminPanelDashboard from "../AdminPanel/AdminPanelDashboard.jsx";
import AdminFooterPage from "../AdminPanel/AdminPages/LayoutBuilder/AdminFooterPage.jsx";
import AdminNavbarPage from "../AdminPanel/AdminPages/LayoutBuilder/AdminNavbarPage.jsx";
import EventsPage from "../../pages/admin/EventsPage.jsx";
import AdminBlogsPage from "../../pages/admin/BlogsPage.jsx";
import AdminProjects from "../../pages/admin/AdminProjects.jsx";

import ComplaintsAdmin from "../../pages/admin/ComplaintsAdmin.jsx";
import AdminContact from "../../pages/admin/AdminContact.jsx";
// import EditNavbar from "../../pages/admin/EditNavbar.jsx";
import ManageDynamicPage from "../../pages/admin/ManageDynamicPage.jsx";
import PartnerManager from "../../pages/admin/PartnerManager.jsx";
import QueryAdmin from "../../pages/admin/QueryAdmin.jsx";
import AdminSolution from "../../pages/admin/AdminSolution.jsx";
import AdminCareer from "../../pages/admin/AdminCareer.jsx";
import AdminAboutPage from "../../pages/admin/AdminAboutPage.jsx";
import AdminClientPage from "../../pages/admin/AdminClientPage.jsx";
import AdminBrands from "../../pages/admin/AdminBrands.jsx";
import AdminCategory from "../../pages/admin/AdminCategory.jsx";
import AdminSubCategory from "../../pages/admin/AdminSubCategory.jsx";
import IpNetworkCategory from "../../pages/admin/IpNetworkCategory.jsx";
import IpNetworkSubCategory from "../../pages/admin/IpNetworkSubCategory.jsx";
import AdminIpNetworkBrands from "../../pages/admin/AdminIpNetworkBrands.jsx";
import AdminProducts from "../../pages/admin/AdminProducts.jsx";
import ProductBannerManager from "../../pages/admin/ProductBannerManager.jsx";
import AdminService from "../../pages/admin/AdminServicePage.jsx";
import AdminApplication from "../../pages/admin/AdminApplication.jsx";
import AdminReviews from "../../pages/admin/AdminReviews.jsx";
import AdminSeo from "../../pages/admin/AdminSeo.jsx";
import PortfolioManagement from "../AdminPanel/AdminPages/PortfolioManagement.jsx";
import IpNetworkCatalogPage from "../../pages/IpNetworkCatalogPage.jsx";
import ProductListing from "../../pages/ProductListing.jsx";

const AdminRoutes = () => {
  return (
    <ProtectedRoute allowedRoles={["admin"]}>
      <Routes>
        <Route element={<AdminPanelLayout />}>
          <Route path="/dynamic-pages" element={<ManageDynamicPage />} />
          <Route path="/product-inquiry" element={<QueryAdmin />} />
          <Route path="/partners" element={<PartnerManager />} />
          <Route path="/solutions" element={<AdminSolution />} />
          <Route path="/service" element={<AdminService />} />
          <Route path="/career" element={<AdminCareer />} />
          <Route path="/about" element={<AdminAboutPage />} />
          <Route path="/dashboard" element={<AdminPanelDashboard />} />
          {/* <Route path="/header" element={<EditNavbar />} /> */}
          <Route path="/footer" element={<AdminFooterPage />} />
          <Route path="/navbar" element={<AdminNavbarPage />} />
          <Route path="/project" element={<AdminProjects />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/blogs" element={<AdminBlogsPage />} />
          <Route
            path="/products"
            element={<AdminProducts key="catalog-products" catalogType="catalog" />}
          />
          <Route path="/complaints" element={<ComplaintsAdmin />} />
          <Route path="/contact" element={<AdminContact />} />
          <Route path="/herobanner" element={<Navigate to="/admin/product-banners" replace />} />
          <Route path="/product-banners" element={<ProductBannerManager />} />
          <Route path="/client" element={<AdminClientPage />} />
          <Route path="/brands" element={<AdminBrands />} />
          <Route path="/category" element={<AdminCategory />} />
          <Route path="/sub-category" element={<AdminSubCategory />} />
          <Route
            path="/ip-network-categories"
            element={<IpNetworkCategory />}
          />
          <Route
            path="/ip-network-subcategories"
            element={<IpNetworkSubCategory />}
          />
          <Route path="/ip-network-brands" element={<AdminIpNetworkBrands />} />
          <Route
            path="/it-products"
            element={<AdminProducts key="ip-network-products" catalogType="ip-network" />}
          />
          <Route path="/applications" element={<AdminApplication />} />
          <Route path="/reviews" element={<AdminReviews />} />
          <Route path="/seo" element={<AdminSeo />} />
          <Route path="/portfolio" element={<PortfolioManagement />} />
          <Route path="/ip-networks" element={<IpNetworkCatalogPage />} />
          <Route
            path="/ip-networks/:categorySlug"
            element={<IpNetworkCatalogPage />}
          />
          <Route
            path="/ip-networks/sub-category/:subCategorySlug"
            element={<ProductListing type="ip-network" />}
          />
        </Route>
      </Routes>
    </ProtectedRoute>
  );
};

export default AdminRoutes;
